import { formatInternational } from '__core/shared/util/phone';
import {
  extractExcerpt,
  formatAsDuration,
  formatAsMoney,
  formatAsTitle,
  processAcronyms,
  replaceNonNumbers,
  replaceTagsUnsafe,
  sanitize,
  sanitizeHtml,
  underscoresToWhitespace
} from '__core/shared/util/transform';

/* eslint-disable no-extend-native  */
/* eslint-disable func-names  */
String.prototype.excerpt = function (length) {
  return extractExcerpt(replaceTagsUnsafe(this), length);
};
String.prototype.onlyNumbers = function () {
  return replaceNonNumbers(this);
};
String.prototype.formatAsDuration = function () {
  return formatAsDuration(this);
};
String.prototype.formatAsPhone = function () {
  let output = this;
  try {
    output = formatInternational(this);
  } catch (err) {
    output = this;
  }
  return String(output);
};
Number.prototype.formatAsPhone = function () {
  return String(this).formatAsPhone();
};
String.prototype.capitalizeFirstLetter = function () {
  return formatAsTitle(this);
};
String.prototype.titleCase = function () {
  return formatAsTitle(this);
};
String.prototype.processAcronyms = function () {
  return processAcronyms(this);
};
String.prototype.sanitize = function () {
  return sanitize(this);
};
String.prototype.underscoresToWhitespace = function () {
  return underscoresToWhitespace(this);
};
String.prototype.formatWithCurrency = function (currency, decimals) {
  return formatAsMoney(this, currency.symbol, decimals || 0, ',', '.');
};

Number.prototype.formatWithCurrency = function (currency, decimals) {
  return formatAsMoney(this, currency.symbol, decimals || 0, ',', '.');
};
String.prototype.formatWithoutCurrency = function () {
  return formatAsMoney(this, '', 0, ',', '.');
};
Number.prototype.formatWithoutCurrency = function () {
  return formatAsMoney(this, '', 0, ',', '.');
};
String.prototype.cleanHtml = function () {
  return sanitizeHtml(this);
};
/* eslint-enable func-names */
/* eslint-enable no-extend-native */
